var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{attrs:{"label":"","description":"The more fields filled in will provide a more comprehensive search and analysis. "}},[_c('toggles-form',{attrs:{"data-array":_vm.toggles},on:{"toggles-change":_vm.handleToggleChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }